import React, {Component} from "react";
import {FJPreviewAction, FJTimeLineAction, FJToolbarAction} from "../../../redux/action/FJRoot.action";
import {connect} from "react-redux";
import FJPreviewTool from "fj-play-control";
import FJCanvasStore from "../../../store/FJCanvasStore";
import styles from '../view/css/FJPreviewToolContainer.module.less';
import key from 'keymaster';
import FJUtil from '../../../util/FJUtil';
import FJCoreUtil from "../../../core/util/FJCoreUtil";

import play from '../../../icon/play.svg';
import fastForwardIcon from '../../../icon/fastForward.svg';
import fastRewindIcon from '../../../icon/fastRewind.svg';
import stopIcon from '../../../icon/stop.svg'
import FJEventConstant from "../../../constant/FJEventConstant";
import FJCoreConstant from "../../../core/constant/FJCoreConstant";
import FJConfig from "../../../config/FJConfig";
import classNames from 'classnames';

class FJPreviewTooContainer extends Component {

  constructor(props) {
    super(props);
    this._isKeyDownNow = false; // 是否按下键盘
    this.state = {
      handleClass: ''
    }
  }

  componentDidMount() {
    FJCanvasStore.executeSync(FJCanvasStore.command.SUBSCRIBE_SELECTION, (ids) => {
      this.props.selectTimeLine(ids[0] ? ids[0] : -1);
    });
    FJCanvasStore.executeSync(FJCanvasStore.command.SUBSCRIBE_PAUSE, () => {
      this.props.stop();
    });
    FJCanvasStore.executeSync(FJCanvasStore.command.SUBSCRIBE_DOUBLE_CLICK_IN_TRACK, (graphType, index = 0) => {
      let {TEXT_ANIMATION, TEXT} = FJCoreConstant;
      if (graphType === TEXT_ANIMATION || graphType === TEXT) {
        this.props.openTextEditPanel(index);
      }
    });

    this._bindEvent()
  }

  componentWillUnmount() {
    this._unBindEvent();
  }

  /**
   * @description 绑定事件
   * @private
   */
  _bindEvent = () => {
    key('left', 'default', this._onLeftKeyPress);
    key('right', 'default', this._onRightKeyPress);
    key('space', 'default', this._onSpacePress);
    window.FJEvent.subscribe(FJEventConstant.PAUSE, this.props.stop);
  };

  /**
   * @description 解除绑定事件
   * @private
   */
  _unBindEvent = () => {
    key.unbind('left', 'default');
    key.unbind('right', 'default');
    key.unbind('space', 'default');
  };

  /**
   * @description 空格快捷键
   * @private
   */
  _onSpacePress = (e) => {
    e.preventDefault();
    FJUtil.hideAllPanel();
    let {
      isPlaying,
      stop,
    } = this.props;

    if (isPlaying) {
      stop();
    } else {
      this._play();
    }
  };

  /**
   * @description 左键按下
   * @private
   */
  _onLeftKeyPress = () => {
    FJUtil.hideAllPanel();
    if (this.props.isDragging || this._isKeyDownNow) {
      return
    }
    this._onMouseDown(1);
    this._isKeyDownNow = true;
    FJCoreUtil.addEvent(document.body, 'keyup', this._onKeyUp);
  };

  /**
   * @description 右键按下
   * @private
   */
  _onRightKeyPress = () => {
    FJUtil.hideAllPanel();
    if (this.props.isDragging || this._isKeyDownNow) {
      return
    }
    this._onMouseDown(2);
    this._isKeyDownNow = true;
    FJCoreUtil.addEvent(document.body, 'keyup', this._onKeyUp);
  };

  /**
   * @description 键盘按下后抬起
   * @param e
   * @private
   */
  _onKeyUp = (e) => {

    let keyCode = e.keyCode;
    if (keyCode === 37 || keyCode === 39) {
      this._isKeyDownNow = false;
      if (e.keyCode === 37) { // 快退
        this._onMouseUp(1);
      } else if (e.keyCode === 39) { // 快进
        this._onMouseUp(2);
      }

      FJCoreUtil.removeEvent(document.body, 'keyup', this._onKeyUp);
    }
  };

  /**
   * @description 按住快进或者快退
   * @param type 1快退 2快进
   * @private
   */
  _onMouseDown = (type) => {
    this._handleClick(type, 'start');
    this._handleClick(type, 'change');
    this._clearTimer();
    this._timeOut = setTimeout(() => {
      this._timeInterval = setInterval(() => {
        this._handleClick(type, 'change');
      }, 100);
    }, 400)
  };

  /**
   * @description 鼠标按下后抬起 快进或者快退
   * @param type 1快退 2快进
   * @private
   */
  _onMouseUp = (type) => {
    this._clearTimer();
    this._timeInterval = null;
    this._timeOut = null;
    this._handleClick(type, 'end');
  };

  /**
   * @description 清除定时器
   * @private
   */
  _clearTimer = () => {
    if (this._timeInterval) {
      clearInterval(this._timeInterval);
    }
    if (this._timeOut) {
      clearTimeout(this._timeOut);
    }
  };

  /**
   * @description 条用快进快退
   * @param type 1快退 2快进
   * @param step
   * @private
   */
  _handleClick = (type, step) => {
    if (type === 1) {
      this.props.fastRewind(step);
    } else if (type === 2) {
      this.props.fastForward(step);
    }
  };

  /**
   * @description 设置播放
   * @private
   */
  _play = () => {
    let {
      play,
      isDragging,
      duration
    } = this.props;

    if (isDragging || duration === 0) {
      return;
    }

    play();
  };

  /**
   * @description 跳转
   * @param type
   * @param progress
   * @private
   */
  _seek = (type, progress) => {
    if ( type === 'start' ) {
      key.setScope('');
      this.setState({
        handleClass: styles.drag_handle
      });
    } else if ( type === 'end' ) {
      key.setScope('default');
      this.setState({
        handleClass: ''
      });
    }

    let {duration} = this.props;
    let __curDuration = this._duration();
    let __progress = progress * __curDuration / duration;
    this.props.seek(type, FJCoreUtil.valueOfInterval(__progress, 0, 1));
  };

  /**
   * @description 返回当前时长，预览区域的进度总时长不能超过maxLimitTime
   * @return {number}
   * @private
   */
  _duration = () => {
    let {duration} = this.props;
    let {maxLimitTime} = FJConfig;
    return FJCoreUtil.valueOfInterval(duration, 0, maxLimitTime);
  };

  render() {

    let {
      fastRewind,
      fastForward,
      isPlaying,
      stop,
      currentTime,
      isDragging
    } = this.props;

    let duration = this._duration();
    let progress = !currentTime || !duration ? 0 : currentTime / duration;

    let classes = {
      toolBoxClassName: styles.box,
      btnClassName: classNames(styles.btn, {[styles.disabled]: duration === 0}),
      slider: {
        sliderBoxClassName: styles.slider_box,
        railClassName: styles.rail,
        trackClassName: styles.track,
        handleClassName: styles.handle + ' ' + this.state.handleClass,
        disableClassName: styles.disabled
      },
    };

    let config = {
      playIcon: play,
      fastForwardIcon: fastForwardIcon,
      fastRewindIcon: fastRewindIcon,
      stopIcon: stopIcon
    };

    return (
      <FJPreviewTool isPlaying={isPlaying}
                     progress={progress}
                     seek={this._seek}
                     fastRewind={fastRewind}
                     play={this._play}
                     stop={stop}
                     fastForward={fastForward}
                     isDragging={isDragging}
                     duration={duration}
                     config={config}
                     classes={classes}
      />
    );
  }
}

const mapStateToProps = function (state) {
  return {
    isPlaying: state.preview.isPlaying,
    isDragging: state.timeline.isDragging,
    duration: state.timeline.duration
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    seek: function (type, progress) {
      dispatch(FJPreviewAction.setVideoProcessAction(type, progress, {isPercent: true, flush: true, useThrottle: true}));
    },
    play: function () {
      dispatch(FJPreviewAction.setVideoPlayAction());
    },
    stop: function () {
      dispatch(FJPreviewAction.setVideoPauseAction());
    },
    fastRewind: function (type) { // 快退
      dispatch(FJPreviewAction.setVideoFastRewindAction(type));
    },
    fastForward: function (type) { // 快进
      dispatch(FJPreviewAction.setVideoFastForwardAction(type));
    },
    selectTimeLine: function (id) {
      dispatch(FJTimeLineAction.selectTimeLineAction(id));
    },
    openTextEditPanel: function (index) {
      dispatch(FJToolbarAction.showEditTextPanelAction(index));
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJPreviewTooContainer);
